module.exports = __webpack_public_path__ + "img/ico_point.1ac4370.svg";